import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType } from '@ngrx/effects';
import * as storesActions from './stores-actions';
import {catchError, exhaustMap, map, takeUntil} from 'rxjs/operators';
import {of, Subject, Subscription} from 'rxjs';
import {StoreService} from '@app/marketplace/stores/_services/store.service';

@Injectable()
export class StoresEffects {

  constructor(private actions$: Actions, private service: StoreService) {}

  loadStores$ = createEffect(() =>
    this.actions$.pipe(
      ofType(storesActions.LOADING_STORES, storesActions.CANCEL_REQUEST),
      exhaustMap((action: any, index) => {
          return this.service.ListStores(action.payload).pipe(
            takeUntil(this.actions$.pipe(ofType(storesActions.CANCEL_REQUEST))),
            map((data: any) => {
              data.count = data.data.length;
              return ({ type: storesActions.LIST_STORES, data });
           }),
            catchError((error) => of({ type: storesActions.ERROR_STORES }))
          );
      })
    )
  );
}
